import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link as RouterLink } from 'react-router-dom';
import {
  Flex,
  View,
  SearchField,
  MenuTrigger,
  ActionButton,
  Menu,
  Item,
} from '@adobe/react-spectrum';
import { searchProvider } from '../../../hooks/searchContext';
import {
  Ul,
  LiWrapper,
  Li,
  Link as StyledLink,
  SearchBoxContainer,
  NavContainer,
} from './styles';

const links = [
  {
    title: 'Projects',
    linkTo: '/',
    isPrivate: false,
  },
  {
    title: 'Calendar',
    linkTo: '/calendar',
    isPrivate: false,
  },
  {
    title: 'My Boards',
    linkTo: '/my-boards',
    isPrivate: false,
  },
  {
    title: '+ Brief',
    linkTo: '/dynamicrequest',
    isPrivate: false,
  },
  {
    title: 'Settings',
    linkTo: '/settings',
    isPrivate: false,
  },
];

const Header = props => {
  const searchFunction = searchProvider();

  const [state, setState] = useState({
    loading: false,
    currentText: '',
  });

  const setCurrentText = text => {
    setState({ ...state, currentText: text });
  };

  const { currentText } = state;

  const handleSearch = useCallback(searchIn => {
    const { key, currentText: searchFor } = searchIn;
    if (key === 'AEM Assets') return searchFunction.onAemSubmit(searchFor);
    if (key === 'CC Libraries') return searchFunction.onCCSubmit(searchFor);
    if (key === 'Adobe Stock') return searchFunction.onSubmit(searchFor);
    if (key === 'Projects') return searchFunction.onProjectsSearch(searchFor);
    if (key === 'Tasks') return searchFunction.onTasksSearch(searchFor);
    return null;
  }, []);

  return (
    <View padding="size-200" margin="0" backgroundColor="static-white">
      <NavContainer>
        <Flex alignItems="center" justifyContent="space-between">
          <Ul>
            {links.map(link => {
              if (link.isPrivate && !props.isAdmin) {
                return null;
              }

              return (
                <LiWrapper key={link.linkTo}>
                  <Li current={link.linkTo === props.location.pathname}>
                    <StyledLink to={link.linkTo}>{link.title}</StyledLink>
                  </Li>
                </LiWrapper>
              );
            })}
          </Ul>

          <Flex
            direction="row"
            width="size-20000"
            gap="size-10"
            alignItems="center"
          >
            <SearchBoxContainer>
              <SearchField
                width="size-5000"
                placeholder="I'm looking for..."
                ActionButton="false"
                onChange={setCurrentText}
              />
              <MenuTrigger>
                <ActionButton>Search</ActionButton>
                <RouterLink style={{ textDecoration: 'none' }} to="/search">
                  <Menu
                    onAction={key => handleSearch({ key, currentText })}
                    isQuiet
                  >
                    <Item key="Projects">Projects</Item>
                    <Item key="Tasks">Tasks</Item>
                    <Item key="AEM Assets">AEM Assets</Item>
                    {/* <Item key="CC Libraries">CC Libraries</Item> */}
                    <Item key="Adobe Stock">Adobe Stock</Item>
                  </Menu>
                </RouterLink>
              </MenuTrigger>
            </SearchBoxContainer>
          </Flex>
        </Flex>
      </NavContainer>
    </View>
  );
};

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  isAdmin: PropTypes.bool,
};

Header.defaultProps = {
  isAdmin: false,
};
export default withRouter(Header);
